import React, { useEffect, useState } from "react";
import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { ArrowUpRight, LayoutDashboard, Package, Files, Mail, ShoppingBag, UserRound, MapPin, LogOut, ShieldCheck, PackagePlus } from "lucide-react";
import { useShopAuth, shopApi } from "../../context/ShopAuthContext";
import "./portal.css";

export const PORTAL = "/mijn-5999cargo";
const nav = [["", "Overzicht", LayoutDashboard], ["/zendingen", "Mijn zendingen", Package],
  ["/pre-alerts", "Pre-alerts", PackagePlus],
  ["/documenten", "Documenten", Files], ["/berichten", "Berichten", Mail],
  ["/bestellingen", "Mijn bestellingen", ShoppingBag], ["/gegevens", "Mijn gegevens", UserRound], ["/adresboek", "Adresboek", MapPin]];

export const PortalLayout = () => {
  const { customer, loading, logout } = useShopAuth();
  const { pathname } = useLocation();
  const [crmName, setCrmName] = useState("");
  useEffect(() => {
    let active = true;
    const refresh = () => {
      if (!customer?.email_verified_at) { setCrmName(""); return; }
      shopApi.get("/customer-portal/profile").then(r => { if (active) setCrmName(r.data.data.first_name || r.data.data.company_name || "Uw account"); })
        .catch(() => { if (active) setCrmName(""); });
    };
    refresh(); window.addEventListener("customer-data-updated", refresh);
    return () => { active = false; window.removeEventListener("customer-data-updated", refresh); };
  }, [customer?.id, customer?.email_verified_at, pathname]);
  const name = crmName || customer?.first_name || "Uw account";
  if (loading) return <div className="p-10" data-testid="portal-session-loading">Account laden…</div>;
  if (!customer) return <Navigate to="/shop-account/login" replace />;
  return <div className="portal" data-testid="customer-portal">
    <header className="portal-header">
      <Link to={PORTAL} className="portal-brand" data-testid="portal-brand"><Package aria-hidden="true" /><span>5999<span className="portal-brand-accent" data-testid="portal-cargo-brand">Cargo</span></span></Link>
      <Link to="/" data-testid="portal-public-home">Naar 5999Cargo <ArrowUpRight size={16} /></Link>
      <button className="portal-mobile-logout" onClick={logout} aria-label="Uitloggen" title="Uitloggen" data-testid="portal-mobile-logout"><LogOut size={17} /></button>
    </header>
    <div className="portal-frame">
      <aside className="portal-sidebar">
        <div className="portal-wordmark" data-testid="portal-name">Mijn 5999Cargo</div>
        <nav aria-label="Mijn 5999Cargo" className="portal-nav">
          {nav.map(([path, label, Icon]) => <NavLink key={label} to={PORTAL + path} end={!path} data-testid={`portal-nav-${path.slice(1) || "overzicht"}`}><Icon size={18} /><span>{label}</span></NavLink>)}
        </nav>
        <div className="portal-identity"><span className="portal-avatar">{name.slice(0, 1).toUpperCase()}</span>
          <div><strong data-testid="portal-customer-name">{name}</strong><span data-testid="portal-verification-state"><ShieldCheck size={13} />{customer.email_verified_at ? "Geverifieerd" : "Verificatie vereist"}</span></div>
          <button onClick={logout} aria-label="Uitloggen" title="Uitloggen" data-testid="portal-logout"><LogOut size={17} /></button>
        </div>
      </aside>
      <main className="portal-main"><Outlet /></main>
    </div>
  </div>;
};

export const PortalHeading = ({ eyebrow, title, children }) => <div className="portal-heading">
  {eyebrow && <p className="portal-eyebrow" data-testid="portal-eyebrow">{eyebrow}</p>}
  <h1 data-testid="portal-page-title">{title}</h1>{children}
</div>;